import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaFacebook, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { springBouncy, EXPO_OUT } from "../utils/animations";

const socials = [
  {
    href: "https://www.facebook.com/almutah.iq",
    Icon: FaFacebook,
    label: "Facebook",
    hoverColor: "hover:text-blue-400 hover:bg-blue-400/10 hover:shadow-[0_0_15px_rgba(59,130,246,0.15)]",
  },
  {
    href: "https://api.whatsapp.com/send/?phone=%2B9647737224466&text&type=phone_number&app_absent=0",
    Icon: FaWhatsapp,
    label: "WhatsApp",
    hoverColor: "hover:text-green-400 hover:bg-green-400/10 hover:shadow-[0_0_15px_rgba(34,197,94,0.15)]",
  },
  {
    href: "mailto:info@almutahco.iq",
    Icon: FaEnvelope,
    label: "Email",
    hoverColor: "hover:text-gold hover:bg-gold/10 hover:shadow-[0_0_15px_rgba(201,162,39,0.15)]",
  },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, ease: EXPO_OUT }}
      className="bg-main py-8 relative overflow-hidden"
    >
      {/* Subtle top border glow */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-highlight/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <motion.p
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="text-white/60 font-cairo text-sm"
          >
            © {year} {t("footer.company")} — {t("footer.rights")}
          </motion.p>

          <div className="flex items-center gap-3">
            {socials.map(({ href, Icon, label, hoverColor }, i) => (
              <motion.a
                key={label}
                initial={{ opacity: 0, y: 15, filter: "blur(4px)" }}
                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 + i * 0.08, ...springBouncy }}
                whileHover={{ scale: 1.25, y: -3 }}
                whileTap={{ scale: 0.9 }}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-9 h-9 flex items-center justify-center rounded-lg text-white/50 transition-all duration-300 ${hoverColor}`}
                aria-label={label}
              >
                <Icon size={18} />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </motion.footer>
  );
}
